(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gaudy-four-panel-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gaudy-rotating-hero')) {
  customElements.define('gaudy-rotating-hero', class GaudyRotatingHero extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.current = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = Math.max(3000, Number(this.dataset.autoplaySpeed) || 6000);
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.designMode = Boolean(window.Shopify && window.Shopify.designMode);
      this.touchStartX = null;
      this.suppressClickUntil = 0;
      this.controller = new AbortController();
      const signal = this.controller.signal;

      if (this.slides.length < 2) return;

      this.prevButton?.addEventListener('click', () => this.goTo(this.current - 1, true), { signal });
      this.nextButton?.addEventListener('click', () => this.goTo(this.current + 1, true), { signal });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index), true), { signal });
      });

      this.addEventListener('mouseenter', () => this.stop(), { signal });
      this.addEventListener('mouseleave', () => this.schedule(), { signal });
      this.addEventListener('focusin', () => this.stop(), { signal });
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.schedule();
      }, { signal });

      this.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch') this.touchStartX = event.clientX;
      }, { signal });

      this.addEventListener('pointerup', (event) => {
        if (event.pointerType !== 'touch' || this.touchStartX === null) return;
        const delta = event.clientX - this.touchStartX;
        this.touchStartX = null;
        if (Math.abs(delta) < 50) return;
        this.suppressClickUntil = Date.now() + 450;
        this.goTo(this.current + (delta < 0 ? 1 : -1), true);
      }, { signal });

      this.addEventListener('click', (event) => {
        if (Date.now() < this.suppressClickUntil && event.target.closest('[data-slide]')) {
          event.preventDefault();
        }
      }, { capture: true, signal });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else this.schedule();
      }, { signal });

      document.addEventListener('shopify:block:select', (event) => {
        const blockId = event.detail && event.detail.blockId;
        const index = this.slides.findIndex((slide) => slide.dataset.blockId === blockId);
        if (index >= 0) {
          this.stop();
          this.goTo(index, false);
        }
      }, { signal });

      document.addEventListener('shopify:block:deselect', () => this.schedule(), { signal });

      this.show(this.current);
      this.schedule();
    }

    disconnectedCallback() {
      this.stop();
      this.controller?.abort();
      this.initialized = false;
    }

    show(index) {
      const normalized = (index + this.slides.length) % this.slides.length;
      this.current = normalized;

      this.slides.forEach((slide, i) => {
        const active = i === normalized;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.tabIndex = active ? 0 : -1;
      });

      this.dots.forEach((dot, i) => {
        const active = i === normalized;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    goTo(index, restart) {
      this.show(index);
      if (restart) {
        this.stop();
        this.schedule();
      }
    }

    schedule() {
      this.stop();
      if (!this.autoplay || this.reducedMotion || this.designMode || document.hidden || this.slides.length < 2) return;
      this.timer = window.setTimeout(() => {
        this.show(this.current + 1);
        this.schedule();
      }, this.speed);
    }

    stop() {
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
